import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import Text from '../../../Text'
import { EpostStatusTimelineContentContainer } from '../EpostStatusTimelineContentContainer'

import { getEpostStatusTimelineRecipientItem } from './EpostStatusTimelineRecipient.utils'

function EpostStatusTimelineRecipient({ user }) {
  const recipient = getEpostStatusTimelineRecipientItem(user)

  return (
    <EpostStatusTimelineContentContainer titleKey='EpostStatusTimeline.RecipientTitleKey'>
      <Avatar avatar={recipient.avatar} size={AVATAR_HEIGHT_24} />
      <Text>{recipient.label}</Text>
    </EpostStatusTimelineContentContainer>
  )
}

export default EpostStatusTimelineRecipient
